export default {
  取消操作: 'Cancel the operation',
  删除选中: 'Delete the check',
  '你确定要删除所选记录吗？': 'Are you sure you want to delete the selected record?',
  你当前选中: 'You are currently selected',
  '条记录，记录中的数据删除后将无法恢复！': 'record, the data in the record will not be able to recover after deletion!',
  批量删除: 'Batch delete',
  '该条记录存在数据，数据删除后将无法恢复，': 'The record has data that can not be recovered after deletion,',
  '确定删除?': 'OK to delete?',
  复制到下一行: 'Copy to the next line',
  复制到最后一行: 'Copy to the last line',
  向上插入行: 'Inserts a row up',
  向下插入行: 'Inserts a row down'
};
